var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemImg',_vm._b({attrs:{"component":"button","type":"button","aria-label":"edit image"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'ItemImg',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }